import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../css/newlisting.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse, faLocation } from '@fortawesome/free-solid-svg-icons';
import {
  FaBuilding, FaStoreAlt,
  FaExpand,
  FaBed,
  FaRegistered,
  FaUserCheck,
  FaHome,
  FaLandmark,
  FaRupeeSign,
  FaArrowsAlt
} from 'react-icons/fa';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import builderData from '../../assets/builders.json';
import {
  FaLightbulb,
  FaCloudRain,
  FaVideo,
  FaDumbbell,
  FaLeaf,
  FaChild,
  FaFootballBall,
  FaSwimmingPool,
  FaPhoneAlt,
  FaLock,
  FaUsers,
  FaWater,
  FaBolt,
  FaDog,
  FaTheaterMasks,
  FaGlassCheers,
  FaDice,
} from "react-icons/fa";
import * as FaIcons from 'react-icons/fa';
import { FiMapPin, FiHome, FiSearch, FiShield } from 'react-icons/fi';
import { LeadPopup } from "./LeadPopup";
import { useParams, useNavigate } from 'react-router-dom';
import { Navbar } from "./Navbar";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";

import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

const iconMap = {
  "street lights": FaLightbulb,
  "Rain Water Harvesting": FaCloudRain,
  "Lift": FaHome,
  "CCTV": FaVideo,
  "Gym": FaDumbbell,
  "Garden": FaLeaf,
  "Kids Area": FaChild,
  "Sports": FaFootballBall,
  "Swimming Pool": FaSwimmingPool,
  "Intercom": FaPhoneAlt,
  "Gated Community": FaLock,
  "Club House": FaHome,
  "Community Hall": FaUsers,
  "Regular Water Supply": FaWater,
  "Power Backup": FaBolt,
  "Pet Allowed": FaDog,
  "MiniTheater": FaTheaterMasks,
  "Mini Party Hall": FaGlassCheers,
  "Indoor games": FaDice,
};

export const Newlistingslanding = () => {

  const [project, setProject] = useState(null);
  const [media, setMedia] = useState([]);
  const [similarProjects, setSimilarProjects] = useState([]);
  const [floorplans, setFloorplans] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const { projectid } = useParams();
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
 const [openFloor, setOpenFloor] = useState(false);
const [floorIndex, setFloorIndex] = useState(0);
const floorSlides = floorplans.map(floor => ({ src: floor.floor_image }));


  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`/api/get-newproject/${projectid}`)
      .then(res => {
        setProject(res.data.project);
        setMedia(res.data.media);
        setFloorplans(res.data.floorplans);
        console.log("floor plan", res.data.floorplans);
        console.log("Latitude:", res.data.project.latitude);
        console.log("Longitude:", res.data.project.longitude);

        setTimeout(() => {
          setShowPopup(true);
        }, 2000);
      })
      .catch(err => {
        console.error("Error fetching project:", err);
      });
  }, []);

  useEffect(() => {
    if (project) {
      axios.get(`/api/similar-projects-newprojects/${project.builder}`)
        .then(res => {
          console.log("res.data", res.data);

          setSimilarProjects(res.data);
        })
        .catch(err => {
          console.error("Error fetching similar projects:", err);
        });
    }
  }, [project]);

  if (!project) return <div>Loading...</div>;

  const builder = builderData.find(
    (b) => b.name.toLowerCase() === project.builder.toLowerCase()
  );

  if (!builder) return null;

  const amenitiesList = project.amenities?.split(',') || [];
  const featuresList = project.features?.split(',') || [];
  const locationList = project.location_advantages?.split(',') || [];
 
  const slides = Array.isArray(media)
    ? media.map((m) => ({ src: m.image }))
    : [];


  const handleLeadsSubmit = async (event) => {
    event.preventDefault();
    const requirements = `intersted in ${project.bpn}`;
    const formData = {
      name: event.target.name.value,
      email: event.target.email.value,
      mobile: event.target.mobile.value,
      requirement: requirements,
      propertyid: project.projectid,
      propertyname: project.bpn,
      projectlocality: project.locality
    };

    try {
      const response = await axios.post("/api/newproject-leads", formData);
      toast.success("Submitted successfully! , Will Reach you soon🚀");

    } catch (err) {
      console.error("Error submitting lead:", err);
      toast.error("Submission failed. Please try again.");
    }

  };

  return (
    <div>
      <Navbar />

      <ToastContainer position="top-right" autoClose={3000} /><div className="landing-container">
        <LeadPopup project={project} projectid={projectid} isOpen={showPopup} onClose={() => setShowPopup(false)} />
        <header className="header">
          <img src={media[0]?.image} alt={project.bpn} className="header-image" />

          <div className="header-overlay">
            <div className="project-info1">
              <h4>{project.pincode}</h4>
              <h1>{project.bpn}</h1>
              <p className="loca"><span role="img" aria-label="">📍</span> {project.locality},{project.city}</p>
              {project.bhk_range && (<p className="unit-type">     {project.bhk_range
  ? project.bhk_range
      .replace(/bhk/gi, '')
      .split(',')
      .map(val => val.trim()) 
      .join(', ')
      .replace(/,([^,]*)$/, ' &$1') + ' BHK'
  : 'N/A'}</p>)}
              
		<p className="price">
  		Starting Price: <strong>
    		{project.min_price && project.max_price
      		? `₹${project.min_price} - ₹${project.max_price}`
      		: project.min_price
      		? `₹${project.min_price}`
      		: project.max_price
      		? `₹${project.max_price}`
     		 : "N/A"}
 		 </strong>
		</p>

              <div className="spotlight-group">
                {Array.isArray(media) &&
                  media.slice(0, 4).map((m, idx) => (
                    m.image && (
                      <div className="sp-2" key={idx} onClick={() => {
                        setIndex(idx);
                        setOpen(true);
                      }}>

                        <img src={m.image} alt={`Spotlight ${idx + 1}`} />
                        {idx === 3 && media.length > 4 && (
                          <div className="overlay">+{media.length - 4}</div>
                        )}

                      </div>
                    )
                  ))}
              </div>
              {media.length > 0 && (
                <Lightbox
                  open={open}
                  close={() => setOpen(false)}
                  index={index}
                  slides={slides}
                  plugins={[Zoom, Thumbnails]}
                />
              )}

            </div>
            <div className="enquiry-form">
              <h3>Connect with Our Property Experts Now!</h3>
              <form onSubmit={handleLeadsSubmit}>
                <input type="text" id="name" name="name" placeholder="Name *" required />
                <input type="email" id="email" name="email" placeholder="Email *" required />
                <input type="tel" id="mobile"
                  name="mobile" placeholder="+91 Mobile *" required />
                <label>
                  <input type="checkbox" required /> I agree to Terms of Use to connect to Propselect.
                </label>
                <button type="submit">Get Instant Callback</button>
              </form>
            </div>
          </div>
        </header>

        <div className="secondary-navbar">
          <ul>
            <li><a href="#overview">OVERVIEW</a></li>
            <li><a href="#amenities">AMENITIES</a></li>
            <li><a href="#features">FEATURES</a></li>
            <li><a href="#location-ad">LOCATION ADVANTAGE</a></li>
            <li><a href="#floor-plans">FLOOR PLANS</a></li>
            <li><a href="#location">LOCATION</a></li>

          </ul>
        </div>
        <div id="overview"></div>


        {/* Overview Section */}
        <section className="overview">
          <div className="container-new">
            <h2>Project Overview</h2>
            <div className="col-lg-12">
              <div className="overview-grid">
                <ul className="overview-list">
                  <li><span ><FaBuilding className="wcu-icon" /> Builder: </span> <br /><p className="para">{project.builder}</p></li>
                  <li><span ><FaStoreAlt className="wcu-icon" />Project Type: </span> <br /><p className="para">{project.project_type}</p></li>
                  <li><span ><FaHome className="wcu-icon" />Sub Type: </span> <br /><p className="para"> {project.property_type}</p></li>
                  <li><span ><FaLandmark className="wcu-icon" />Unit Size:</span> <br /> <p className="para">{project.starting_unit_size} - {project.end_unit_size} Sq.Ft</p></li>
                  {project.bhk_range && (<li><span ><FaBed className="wcu-icon" />Project Plan:</span> <br /> <p className="para">    {project.bhk_range
  ? project.bhk_range
      .replace(/bhk/gi, '')
      .split(',')
      .map(val => val.trim())
      .join(', ')
      .replace(/,([^,]*)$/, ' &$1') + ' BHK'
  : 'N/A'}</p></li>)}
                  <li><span ><FaExpand className="wcu-icon" />Status:</span> <br /> <p className="para">{project.project_status}</p></li>
                  <li><span ><FaRupeeSign className="wcu-icon" />Price:</span> <br /> <p className="para">₹{project.min_price} - ₹{project.max_price} Onwards</p></li>
                  <li><span ><FaRegistered className="wcu-icon" />RERA No:</span> <br /><p className="para">{project.rera_no}</p></li>
                  <li><span ><FaUserCheck className="wcu-icon" />Project Size:</span><br /> <p className="para">{project.project_sq} Acres</p></li>
                  {project.totalfloors && (<li><span ><FaArrowsAlt className="wcu-icon" />Total Floors:</span><br /> <p className="para">{project.totalfloors}</p></li>
)}                </ul>
             </div>
            </div>
          </div>
        </section>

        {/* Image and About */}
        <section className="about-section">
          <div className="container-about">
            <img src={media[0]?.image} alt="Brigade " className="building-image" />
            <div className="about-text">
              <h3>About</h3>
              <h2>
  {project.property_type === 'Plot'
    ? `${project.builder} ${project.project_type} Plot for sale in ${project.locality}, Chennai`
    : `${project.builder} ${project.locality}: Price, Floor Plans, Reviews`}
</h2>
              <p>
                {project.description}
              </p>
            </div>
          </div>
        </section>
        <div id="amenities"> </div>

        <div className=" btn-enquiry">
          <button className="enquire" onClick={() => setShowPopup(true)}> Enquire Now for Schedule Site Visit</button>
        </div>

        <div id="amenities" className="amenities-section">
          <div className="container-ame">
            <h2 className="section-title">{project.builder} Amenities</h2>
            <Slider
              dots={false}
              infinite={true}
              speed={500}
              slidesToShow={4}
              slidesToScroll={1}
              autoplay={true}
              autoplaySpeed={2500}
              arrows={false}
              responsive={[
                {
                  breakpoint: 1024,
                  settings: { slidesToShow: 3 },
                },
                {
                  breakpoint: 768,
                  settings: { slidesToShow: 2 },
                },
                {
                  breakpoint: 480,
                  settings: { slidesToShow: 1 },
                },
              ]}
            >
              {amenitiesList.map((amenity, idx) => (
                <div className="amenities-grid-item" key={idx}>

                  {iconMap[amenity.trim()] ? React.createElement(iconMap[amenity.trim()], { className: "ame-icons" })
                    : <FaLightbulb className="ame-icons" />}
                  <h3>{amenity.trim()}</h3>
                </div>
              ))}

            </Slider>

          </div>
        </div>
        <div id="features"></div>
        <div className=" btn-enquiry">
          <button className="enquire" onClick={() => setShowPopup(true)}> Enquire Now for Schedule Site Visit</button>
        </div>

        {/* Location Advantages */}
        <div className="location-advantage">
          <div className="container-location">
            <h2 className="section-title">{project.builder} Features</h2>
            <ul className="location-grid">
              {featuresList.map((feature, idx) => (
                <li className="location-card" key={idx}>
                  <p>{feature.trim()}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="scroll-ad" id="location-ad"></div>
        <div className="location-advantage">
          <div className="container-location">
            <h2 className="section-title">Location Advantages</h2>
            <ul className="location-grid">
              {locationList.map((location, idx) => (
                <li className="location-card" key={idx}>
                  <p>{location.trim()}</p>
                </li>
              ))}
            </ul>

          </div>
        </div>

        <div id="floor-plans"></div>
        <div className=" btn-enquiry">
          <button className="enquire" onClick={() => setShowPopup(true)}> Enquire Now for Schedule Site Visit</button>
        </div>
        <div className="floor-plans-section">
          <div className="container-floor">
           
<h2>
  {project.property_type === 'Plot'
    ? `${project.builder} Site Plan`
    : `${project.builder} Floor Plans`}
</h2>
            <ul className="floor-plans-grid">
              {floorplans.map((floor, idx) => (
                <div key={idx} className="floor-plan-item">
                  <img src={floor.floor_image} alt={`Floor plan ${idx + 1}`}  onClick={() => {
                      setFloorIndex(idx);
                      setOpenFloor(true);
                    }}
                    style={{ cursor: 'pointer' }} />
		 
		 {project.property_type === "Plot" ? (
        floor.floor_unitsize && <h3>UnitSize: {floor.floor_unitsize}</h3>
      ) : (
        <>
          <h3>BHK: {floor.floor_bhk} | {floor.floor_toilet}</h3>
          <h3>Carpet Area: {floor.floor_carpet}</h3>
          {floor.floor_unitsize && <h3>UnitSize: {floor.floor_unitsize}</h3>}
        </>
      )}
                  <button onClick={() => setShowPopup(true)}>Get Price Details</button>
                </div>
              ))}
            </ul>
          </div>
        </div>

 {floorSlides.length > 0 && (
          <Lightbox
            open={openFloor}
            close={() => setOpenFloor(false)}
            index={floorIndex}
            slides={floorSlides}
            plugins={[Zoom, Thumbnails]}
          />
        )}
        <div id="location"></div>
        <div className=" btn-enquiry">
          <button className="enquire" onClick={() => setShowPopup(true)}> Enquire Now for Schedule Site Visit</button>
        </div>

        <div id="location" className="location-section">
          <div className="container-location-map">
            <h2 className="section-title"> Location Map</h2>
            {project && project.latitude && project.longitude ? (
              <>
                <iframe
                  title="Property Location"
                  width="100%"
                  height="300"
                  style={{ border: "0", marginTop: "10px", borderRadius: "8px" }}
                  src={`https://www.google.com/maps?q=${project.latitude},${project.longitude}&output=embed`}
                  allowFullScreen
                ></iframe>

              </>
            ) : (
              <p>Map not available for this address.</p>
            )}
          </div>
        </div>

        <div className=" btn-enquiry">
          <button className="enquire" onClick={() => setShowPopup(true)}> Enquire Now for Schedule Site Visit</button>
        </div>

       {/* <div className="about-builder">
          <div className="container-about-builder">
            <h2 className="section-title">About {builder.name}</h2>
            <div className="builder-info">
              <p>{builder.description}</p>

            </div>
          </div>
        </div> */}


        <div className="similar-projects-section">
          <h2 className="section-title">More Projects by {project.builder}</h2>
          <div className="projects-grid">
            {Array.isArray(similarProjects) && similarProjects.map((project) => (
              <a
                key={project.projectid}
                href={`/new-project/${project.projectid}`}
                target="_blank"
                rel="noopener noreferrer"
                className="property-card1"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className="card-image">
                  <img src={project.image} alt={project.bpn} />
                  <span className="badge verified "><FiShield /> Verified</span>
                  <span className="badge status">{project.pincode}</span>
                </div>
                <div className="card-content">
                  <h3>{project.bpn}</h3>
                  <p className="developer">{project.builder}</p>

                  <p className="icon-text">
                    <FiMapPin /> {project.city}, {project.locality}
                  </p>
                  <div className='flex'>
                    <p className="icon-text">
                      <FiHome />{project.bhk_range
  ? project.bhk_range
      .replace(/bhk/gi, '')
      .split(',')
      .map(val => val.trim()) // Trim spaces
      .join(', ')
      .replace(/,([^,]*)$/, ' &$1') + ' BHK'
  : 'N/A'}
                    </p>
                    <p className="icon-text">
                      ₹{project.min_price} - ₹{project.max_price}
                    </p>
                  </div>
                  <div className="card-actions">
                    <button className="btn view">
                      <FiSearch /> View Details
                    </button>

                  </div>
                </div>
              </a>
            ))
            }
          </div>
        </div>

      </div></div>
  )
}
